import { EnvironmentTypes } from './enums';
import { Environment } from './models';

const STAGE_DOMAIN = 'https://pg-stage.rpd.cloud';
const { origin } = window.location;

const reactAppEnv = process.env.REACT_APP_ENV as EnvironmentTypes;

const dev: Environment = {
  type: EnvironmentTypes.Development,
  production: false,
  origin: STAGE_DOMAIN,
  wsUrl: `${STAGE_DOMAIN}/signalr`,
  filesUrl: `${STAGE_DOMAIN}/pg-files`,
  jackpotWSUrl: `${STAGE_DOMAIN}/pg-jackpot-api/signalr`,
  otlpUrl: '',
  telemetrySampleRate: 1,
  gameLaunchIdParam: false,
};

const stage: Environment = {
  type: EnvironmentTypes.Staging,
  production: false,
  origin: origin,
  wsUrl: `${origin}/signalr`,
  filesUrl: `${origin}/pg-files`,
  jackpotWSUrl: `${origin}/pg-jackpot-api/signalr`,
  otlpUrl: `${origin}/api/telemetry/traces`,
  telemetrySampleRate: 1,
  gameLaunchIdParam: false,
};

const live: Environment = {
  type: EnvironmentTypes.Production,
  production: true,
  origin: origin,
  wsUrl: `${origin}/signalr`,
  filesUrl: `${origin}/pg-files`,
  jackpotWSUrl: `${origin}/pg-jackpot-api/signalr`,
  otlpUrl: `${origin}/api/telemetry/traces`,
  telemetrySampleRate: 0.05,
  gameLaunchIdParam: false,
};

const envs = {
  [EnvironmentTypes.Development]: dev,
  [EnvironmentTypes.Staging]: stage,
  [EnvironmentTypes.Production]: live
};

export const env = envs[reactAppEnv];

// Short commit SHA baked in by the Docker build (SPA_VERSION build arg); "dev" for local builds.
export const spaVersion = (process.env.REACT_APP_VERSION || 'dev').slice(0, 32);
